import React from "react";
import { FiCheckCircle, FiLayers } from "react-icons/fi";
import { Link } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";
import {
  HeroAction,
  HeroCard,
  HeroEyebrow,
  HeroMeta,
  HeroTitle,
} from "./styles";

export const ROTA_CAPACIDADE_FABRICA = "/legado/capacidade";
export const PERM_CAPACIDADE_FABRICA = "capacidade_fabrica:view";

function formatarCarga(valor) {
  if (valor == null || !Number.isFinite(valor)) return "—";
  return valor.toLocaleString("pt-BR", { maximumFractionDigits: 1 });
}

/**
 * Link para a capacidade MEDIDA (ritmo real dos términos). A "utilização" que
 * este cartão mostrava dividia a carga por uma capacidade fixa de 4 ambientes
 * por dia útil que ninguém calibrou; saiu para não haver dois números de
 * capacidade discordando.
 */
function LinkCapacidadeMedida() {
  const { hasPermission } = useAuth() || {};
  if (!hasPermission?.(PERM_CAPACIDADE_FABRICA)) return null;
  return (
    <span>
      <Link to={ROTA_CAPACIDADE_FABRICA}>Capacidade medida da fábrica →</Link>
    </span>
  );
}

export default function BottleneckCard({ gargalo, janelaDiasUteis = 7 }) {
  if (!gargalo) {
    return (
      <HeroCard
        $tone="neutral"
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
      >
        <HeroEyebrow>
          <FiCheckCircle style={{ verticalAlign: "-2px", marginRight: 6 }} />
          Sem carga nas etapas
        </HeroEyebrow>
        <HeroTitle>Nenhuma etapa com ambiente na fila</HeroTitle>
        <HeroMeta>
          <span>
            Nenhum ambiente está numa etapa nem chegando a ela nesta janela de {janelaDiasUteis} dias úteis.
          </span>
          <LinkCapacidadeMedida />
        </HeroMeta>
      </HeroCard>
    );
  }

  return (
    <HeroCard
      $tone="neutral"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      role="region"
      aria-label="Etapa com maior carga"
    >
      <HeroEyebrow>
        <FiLayers style={{ verticalAlign: "-2px", marginRight: 6 }} />
        Etapa com maior carga
      </HeroEyebrow>
      <HeroTitle>{gargalo.label}</HeroTitle>
      <HeroMeta>
        <span>
          Carga: <strong>{formatarCarga(gargalo.cargaComplexidade)}</strong> (complexidade dos ambientes na
          etapa, mais os que estão chegando com peso menor)
        </span>
        <span>
          <strong>{gargalo.countWip}</strong> ambiente(s) na fila + {" "}
          <strong>{gargalo.countChegando}</strong> chegando
        </span>
        {gargalo.pretosNaEtapa > 0 && (
          <span>
            Pulmões pretos na etapa: <strong>{gargalo.pretosNaEtapa}</strong>
          </span>
        )}
        <LinkCapacidadeMedida />
      </HeroMeta>
      <HeroAction href="#playbook">
        Ação imediata sugerida → ver playbook abaixo
      </HeroAction>
    </HeroCard>
  );
}
